import { ElementProps } from "@/types/elements";

const H1Element = ({ block }: ElementProps) => {
    return (
        <p className="text-2xl font-medium text-gray-600 font-DMSerifDisplay">
            {block.data.text}
        </p>
    )
}
export default H1Element;